import { render, staticRenderFns } from "./ConfigSystemSystemLabels.vue?vue&type=template&id=1ac0d8f8&scoped=true&"
import script from "./ConfigSystemSystemLabels.vue?vue&type=script&lang=js&"
export * from "./ConfigSystemSystemLabels.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSystemSystemLabels.vue?vue&type=style&index=0&id=1ac0d8f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0d8f8",
  null
  
)

export default component.exports